import {actionTypes, flightTypes} from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import {serialize} from "../functions";
import {appNotification} from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';

var ArrivalCenteringBlock = {
    controller: function (args) {
        //this.showFuelBlock = !args.openSkyBlocksShow;
        this.showFuelBlock = true;
    },
    view: function (ctrl) {
        return m("", [
            m(".row", [
                m(".col-xs-12[style='padding:5px 15px']", "Центровка")
            ]),
            m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Вес почты"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='ArrMailWeight'][type='text']", {
                            value: BoardCentering.data.ArrMailWeight,
                            disabled: BoardCentering.editDisabled
                        }),
                        m(".input-group-addon", "кг")
                    ])
                ])
            ]),
            m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Вес груза"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='ArrCargoWeight'][type='text']", {
                            value: BoardCentering.data.ArrCargoWeight,
                            disabled: BoardCentering.editDisabled
                        }),
                        m(".input-group-addon", "кг")
                    ])
                ])
            ]),
            m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Количество контейнеров"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='ArrContainers'][type='text']", {
                            value: BoardCentering.data.ArrContainers,
                            disabled: BoardCentering.editDisabled
                        }),
                        m(".input-group-addon", "шт")
                    ])
                ])
            ]),
            //ctrl.showFuelBlock ?
            // [
            //     m(".row", [
            //         m(".col-xs-12[style='padding:5px 15px']", "Топливо")
            //     ]),
            //     ,
            //     // --------------
            //     m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [

            //         //m(".control-label.col-xs-6",
            //         [
            //             m.component(FuelMultiple, [BoardCentering.fuels])
            //         ]//, "Общая заправка 1")
            //     ]),
            //     m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
            //         m("label.control-label.col-xs-6", "Топливо остаток"),
            //         m(".col-xs-6", [
            //             m(".input-group", [
            //                 m("input.form-control[name='ArrFuelRest'][type='text']", {
            //                     BoardCentering: BoardCentering.data.ArrFuelRest,
            //                     disabled: BoardCentering.editDisabled
            //                 }),
            //                 m(".input-group-addon", "кг")
            //             ])
            //         ])
            //     ]),
            //     m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
            //         m("label.control-label.col-xs-6", "Топливо заправка"),
            //         m(".col-xs-6", [
            //             m(".input-group", [
            //                 m("input.form-control[name='ArrFuelFill'][type='text']", {
            //                     BoardCentering: BoardCentering.data.ArrFuelFill,
            //                     disabled: BoardCentering.editDisabled
            //                 }),
            //                 m(".input-group-addon", "кг")
            //             ])
            //         ])
            //     ]),
            //     m(".form-group.bg-info[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
            //         m("label.control-label.col-xs-6", "Топливо расход"),
            //         m(".col-xs-6", [
            //             m(".input-group", [
            //                 m("input.form-control[name='ArrFuelUse'][type='text']", {
            //                     BoardCentering: BoardCentering.data.ArrFuelUse,
            //                     disabled: BoardCentering.editDisabled
            //                 }),
            //                 m(".input-group-addon", "кг")
            //             ])
            //         ])
            //     ])
            // ] //: ''
        ])
    }
};

var FuelMultiple = {
    list: [],
    controller: function (fuellist) {
        var self = this;
        FuelMultiple.list = fuellist[0];

        // #DEGUG
        //FuelMultiple.list.push({id: 0, number: FuelMultiple.list.length + 1, value: 124, deleted:false});
        //FuelMultiple.list.push({id: 0, number: FuelMultiple.list.length + 1, value: 544, deleted:false});
        // #END DEBUG

        this.addFuel = function () {
            BoardCentering.fuels.push({FuelingId: '0', FuelingNumber: FuelMultiple.list.length + 1, FuelAmount : "", FuelDensity:"", ClaimNumber : ""});
            loader.hide();
        },
            this.del = function (index) {
                BoardCentering.fuels.splice(index,1);
                loader.hide();
            }

        if (FuelMultiple.list.length == 0)
            this.addFuel();
    },

    view : function (ctrl) {
        if (BoardCentering.fuels.length == 0)
        {
            BoardCentering.fuels.push({FuelingId: '0', FuelingNumber: BoardCentering.fuels.length + 1, FuelAmount : "", FuelDensity:"", ClaimNumber : ""})
        }

        return BoardCentering.fuels.length > 0 ?

            m(".fuels-block", [
                !BoardCentering.editDisabled ? m("", [m(".btn.btn-info[style='float:right']", {onclick: ctrl.addFuel.bind(null, []) }, "Добавить")]) : m(""),
                m("input[name='Fuels_Count'][type='hidden']", {value: BoardCentering.fuels.length}),
                m("table.table", [
                    m("tr", [
                        m("th[style='text-align: center']", "№"),
                        m("th[style='text-align: center']", "Кол-во"),
                        m("th[style='text-align: center']", "Плотность"),
                        m("th[style='text-align: center']", "Номер требования"),
                        !BoardCentering.editDisabled ? m("th", "") : m(""),
                    ]),

                    BoardCentering.fuels.map(
                        function (fuel, index) {
                            BoardCentering.fuels[index].FuelingNumber = index + 1;
                            return [
                                m("tr", [
                                    m("td[style='text-align: center']", [
                                        m("input[name='Fuel_"+index+"_FuelingId'][type='hidden']", {
                                            value: fuel.FuelingId ? fuel.FuelingId : 0
                                        })
                                    ], BoardCentering.fuels[index].FuelingNumber),
                                    m("td", [
                                        m("input.form-control[name='Fuel_"+index+"_Amount'][type='text']", {
                                            value: BoardCentering.fuels[index].FuelAmount,
                                            disabled: BoardCentering.editDisabled,
                                            onchange: function(e) {
                                                e.target["value"] = e.target["value"].replace(",", ".");
                                                if (isNaN(e.target["value"]) || e.target["value"] <= 0) e.target["value"] = "";
                                                BoardCentering.fuels[index].FuelAmount = e.target["value"];

                                            }
                                        })
                                    ]),
                                    m("td", [
                                        m("input.form-control[name='Fuel_"+index+"_Density'][type='text']", {
                                            value: fuel.FuelDensity,
                                            disabled: BoardCentering.editDisabled,
                                            onchange: function(e) {
                                                e.target["value"] = e.target["value"].replace(",", ".");
                                                if (isNaN(e.target["value"]) || e.target["value"] <= 0) e.target["value"] = "";
                                                BoardCentering.fuels[index].FuelDensity = e.target["value"];
                                            }
                                        })
                                    ]),
                                    m("td", [
                                        m("input.form-control[name='Fuel_"+index+"_ClaimNumber'][type='text']", {
                                            value: fuel.ClaimNumber,
                                            disabled: BoardCentering.editDisabled,
                                            onchange: function(e) {
                                                // if (e.target["value"] < 0) e.target["value"] = 0;
                                                var expr = /^[A-zА-я0-9\s\d-_]*$/gi;
                                                var str = e.target["value"];
                                                var r = expr.test(str);
                                                if (!r)
                                                    e.target["value"] = "";
                                                BoardCentering.fuels[index].ClaimNumber = e.target["value"];
                                            }
                                        })
                                    ]),
                                    !BoardCentering.editDisabled ? m("td[style='text-align: center']", [
                                        m("i.fa.fa-2x.fa-trash-o", {onclick: ctrl.del.bind(this, index),
                                            disabled: BoardCentering.editDisabled })
                                    ]) : m("")
                                ])]
                        }
                    )
                ])
            ]) : m("");

    }


}

var DepartureCenteringBlock = {
    controller: function (args) {
        // this.showFuelBlock = !args.openSkyBlocksShow;
        this.showFuelBlock = true;
    },
    view: function (ctrl) {
        return m("", [
            m(".row", [
                m(".col-xs-12[style='padding:5px 15px']", "Центровка")
            ]),
            m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Базовый вес ВС"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='DepBasicWeight'][type='text']", {
                            value: BoardCentering.data.DepBasicWeight,
                            disabled: BoardCentering.editDisabled
                        }),
                        m(".input-group-addon", "кг")
                    ])
                ])
            ]),
            m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Индекс центровки ВС"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='DepBalanceIndex'][type='text']", {
                            value: BoardCentering.data.DepBalanceIndex,
                            disabled: BoardCentering.editDisabled
                        }),
                        m(".input-group-addon", "%")
                    ])
                ])
            ]),
            m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Снаряженный вес ВС"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='DepCurbWeight'][type='text']", {
                            value: BoardCentering.data.DepCurbWeight,
                            disabled: BoardCentering.editDisabled
                        }),
                        m(".input-group-addon", "кг")
                    ])
                ])
            ]),
            m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Вес ВС без топлива"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='DepDryOperatingWeight'][type='text']", {
                            value: BoardCentering.data.DepDryOperatingWeight,
                            disabled: BoardCentering.editDisabled
                        }),
                        m(".input-group-addon", "кг")
                    ])
                ])
            ]),
            m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Макс. посадочный вес ВС"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='DepMaxLandingWeight'][type='text']", {
                            value: BoardCentering.data.DepMaxLandingWeight,
                            disabled: BoardCentering.editDisabled
                        }),
                        m(".input-group-addon", "кг")
                    ])
                ])
            ]),
            m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                m("label.control-label.col-xs-6", "Макс. взлетный вес ВС"),
                m(".col-xs-6", [
                    m(".input-group", [
                        m("input.form-control[name='DepMaxTakeOffWeight'][type='text']", {
                            readonly: 'readonly',
                            value: BoardCentering.data.DepMaxTakeOffWeight
                        }),
                        m(".input-group-addon", "кг")
                    ])
                ])
            ]),
            //ctrl.showFuelBlock ?
            [
                m(".row", [
                    m(".col-xs-12[style='padding:5px 15px']", "Топливо")
                ]),
                // --------------
                m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [

                    //m(".control-label.col-xs-6",
                    [
                        m.component(FuelMultiple, [BoardCentering.fuels])
                    ]//, "Общая заправка 1")
                ]),
                // --------------
                m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                    m("label.control-label.col-xs-6", "Топлива на руление"),
                    m(".col-xs-6", [
                        m(".input-group", [
                            m("input.form-control[name='DepFuelTow'][type='text']", {
                                value: BoardCentering.data.DepFuelTow,
                                disabled: BoardCentering.editDisabled
                            }),
                            m(".input-group-addon", "кг")
                        ])
                    ])
                ]),
                m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                    m("label.control-label.col-xs-6", "Топлива на взлет"),
                    m(".col-xs-6", [
                        m(".input-group", [
                            m("input.form-control[name='DepFuelTakeOff'][type='text']", {
                                value: BoardCentering.data.DepFuelTakeOff,
                                disabled: BoardCentering.editDisabled
                            }),
                            m(".input-group-addon", "кг")
                        ])
                    ])
                ]),
                m(".form-group.bg-danger[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", [
                    m("label.control-label.col-xs-6", "Топлива на полет"),
                    m(".col-xs-6", [
                        m(".input-group", [
                            m("input.form-control[name='DepFuelTrip'][type='text']", {
                                value: BoardCentering.data.DepFuelTrip,
                                disabled: BoardCentering.editDisabled
                            }),
                            m(".input-group-addon", "кг")
                        ])
                    ])
                ])
            ] //: ''
        ])
    }
};

var BoardCentering = {
    error: '',
    alert: '',
    time: null,
    data: {},
    fuel: {},
    fuels: [],
    boards: [],
    newBoardAddDisabled: false,
    editDisabled: false,
    openSkyBlocksShow: false,
    load: function () {
        return m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/centering'
        }).then(function (response) {
            server.setOnline();

            BoardCentering.time = response.time;
            BoardCentering.data = response.centering;
            BoardCentering.boards = response.boards;
            BoardCentering.fuel = response.fuel;
            BoardCentering.fuels = response.fuels;

            appNotification.list = response.notifications;

            BoardCentering.newBoardAddDisabled = response.config.newBoardAddDisabled;
            BoardCentering.editDisabled = response.config.boardCenteringEditDisabled;
            BoardCentering.openSkyBlocksShow = response.config.openSkyBlocksShow;

            storage.config = response.config;

            server.initPing();
            appNotification.init();

            loader.hide();

            return response;
        }, function (response) {
            if (response && response.message) {
                BoardCentering.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    save: function (e) {
        e.preventDefault();
        BoardCentering.error = '';
        loader.show();

        var data = serialize(e.target);
        data.Fuels = BoardCentering.fuels;
        var CanSaveFuel = true;
        for(var i = 0; i < BoardCentering.fuels.length; i++)
        {
            //проверка не целое ли число и больше ли оно нуля
            if(BoardCentering.fuels[i].FuelDensity > 0 && !((Number(BoardCentering.fuels[i].FuelDensity) ^ 0) === Number(BoardCentering.fuels[i].FuelDensity))) {
                BoardCentering.fuels[i].FuelDensity = Number(BoardCentering.fuels[i].FuelDensity).toFixed(3);
            }
            // BoardCentering.fuels.push({FuelingId: '0', FuelingNumber: BoardCentering.fuels.length + 1, FuelAmount : "", FuelDensity:"", ClaimNumber : ""})
            if ((BoardCentering.fuels[i].FuelAmount <= 0 || BoardCentering.fuels[i].FuelDensity <= 0 || BoardCentering.fuels[i].ClaimNumber == "") &&
                (BoardCentering.fuels[i].FuelAmount != "" && BoardCentering.fuels[i].FuelDensity != "" && BoardCentering.fuels[i].ClaimNumber != ""))
            {
                CanSaveFuel = false;
            }
        }

        if (!CanSaveFuel)
        {
            alert("Заполнены не все поля блока Топливо или введены недопустимые значения!");
            loader.hide();
            return;
        }

        m.request({
            method: 'PUT',
            url: '/api/task/' + m.route.param('taskId') + '/centering',
            data: data
        }).then(function () {
            server.setOnline();
            loader.hide();
            m.route('/task/' + m.route.param('taskId') + '/centering');
        }, function (response) {

            data.type = actionTypes.centeringUpdate;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                BoardCentering.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    saveFuel: function (e) {
        e.preventDefault();
        BoardCentering.alert = '';
        loader.show();

        var data = serialize(e.target);
        data.fuels = BoardCentering.fuels;

        m.request({
            method: 'PUT',
            url: '/api/flight/' + data.flightId + '/fuel',
            data: data
        }).then(function (response) {
            server.setOnline();
            loader.hide();

            BoardCentering.fuel = response.data;
        }, function (response) {

            data.type = actionTypes.flightFuelSave;
            cache.push(data);

            if (response && response.message) {
                BoardCentering.alert = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    newBoard: function (e) {
        e.preventDefault();
        BoardCentering.error = '';
        loader.show();

        var boardName = e.target.boardId.options[e.target.boardId.selectedIndex].text;

        var data = {
            boardId: e.target.boardId.value,
            boardNumber: e.target.boardNumber.value || boardName,
            maxFlightWeight: e.target.maxFlightWeight.value
        };

        m.request({
            method: 'POST',
            url: '/api/task/' + m.route.param('taskId') + '/board',
            data: data
        }).then(function () {
            server.setOnline();
            loader.hide();
            m.route('/task/' + m.route.param('taskId') + '/centering');
        }, function (response) {

            data.type = actionTypes.createNewBoard;
            data.taskId = m.route.param('taskId');
            cache.push(data);

            if (response && response.message) {
                BoardCentering.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

export var BoardCenteringPage = {
    controller: function () {

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        var data = BoardCentering.load();

        return {
            data: data,
            topMenu: [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ],
            showMaxFlightWeightForm: false,
            showCreateNewBoard: false
        }
    },
    view: function (ctrl) {

        var boardNumbers = [];

        return typeof ctrl.data() == 'undefined'
            ? []
            : [
                m.component(HeaderMenuBlock, {
                    time: BoardCentering.time,
                    menu: ctrl.topMenu
                }),
                m("div[style='margin-top:0px']", ''),
                m.component(flightMenuBlock, {
                    board: ctrl.data().board,
                    menu: ctrl.data().menu,
                    tasks: ctrl.data().tasks,
                    currentTask: ctrl.data().currentTask,
                    tab: 'centering'
                }),
                BoardCentering.error,
                m(".container[style='padding-top:10px']", [
                    m("", [
                        m("button.btn.btn-primary.btn-block.btn-lg[style='margin-bottom:10px']", {
                            disabled: BoardCentering.boards.length ? false : 'disabled',
                            onclick: function () {
                                ctrl.showMaxFlightWeightForm = !ctrl.showMaxFlightWeightForm;
                            }
                        }, "Максимальная взлетная масса"),
                        m("form.form-horizontal", {
                            class: ctrl.showMaxFlightWeightForm ? false : 'hidden',
                            onsubmit: BoardCentering.newBoard.bind(ctrl)
                        }, [
                            m(".form-group", [
                                m("label.control-label.col-xs-6[style='padding-right:5px']", "Борт:"),
                                m("label.control-label.col-xs-6[style='padding-right:5px']", "Вес:"),
                                m(".col-xs-6[style='padding:0; padding-left:15px']", [
                                    m("select.form-control.input-lg[name='boardId']", {
                                        class: ctrl.showCreateNewBoard ? 'hidden' : false,
                                        onchange: function (e) {
                                            document.querySelector('input[name=maxFlightWeight]').value = boardNumbers[e.target.value];
                                        }
                                    }, [
                                        BoardCentering.boards.map(function(board) {
                                            boardNumbers[board.id] = board.maxFlightWeight;
                                            return m("option", {
                                                value: board.id,
                                                selected: ctrl.data().board.boardNumber == board.number
                                            }, board.number);
                                        })
                                    ]),
                                    m("input.form-control.input-lg[type='text'][name='boardNumber']", {
                                        class: ctrl.showCreateNewBoard ? false : 'hidden'
                                    })
                                ]),
                                m(".col-xs-6[style='padding-left:0']", [
                                    m("input.form-control.input-lg[type='text'][name='maxFlightWeight']", {
                                        disabled: !ctrl.showCreateNewBoard,
                                        config: function (element, isInitialized) {
                                            if (!isInitialized) {
                                                element.value = boardNumbers[document.querySelector('select[name=boardId]').value];
                                            }
                                        }
                                    })
                                ])
                            ]),
                            BoardCentering.newBoardAddDisabled ?
                                m(".container[style='padding:0']", [
                                    m("button.btn.btn-success.btn-block.btn-lg[type='submit']", "Сохранить")
                                ]) :
                                [
                                    m(".col-xs-6[style='padding:0 3px 0']", [
                                        m("button.btn.btn-info.btn-block.btn-lg[type='button']", {
                                            onclick: function () {
                                                ctrl.showCreateNewBoard = !ctrl.showCreateNewBoard;
                                                if (ctrl.showCreateNewBoard) {
                                                    document.querySelector('input[name=maxFlightWeight]').value = '';
                                                } else {
                                                    document.querySelector('input[name=maxFlightWeight]').value = boardNumbers[document.querySelector('select[name=boardId]').value];
                                                }
                                            }
                                        }, "Новый борт")
                                    ]),
                                    m(".col-xs-6[style='padding:0 0 0 3px']", [
                                        m("button.btn.btn-success.btn-block.btn-lg[type='submit']", {
                                            // disabled: !ctrl.showCreateNewBoard
                                        }, "Сохранить")
                                    ])
                                ]
                        ])
                    ]),
                    m("form.form-horizontal[style='margin-top:10px']", {
                        onsubmit: BoardCentering.save.bind(ctrl)
                    }, [
                        m("input[type='hidden'][name='flightType']", { value: BoardCentering.data.flightType }),
                        m(".row", [
                            m(".col-xs-12[style='padding:5px 15px']", "Экипаж")
                        ]),
                        m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                            class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                        }, [
                            m("label.control-label.col-xs-3", "КВС"),
                            m(".col-xs-9", [
                                m("input.form-control[name='Captain'][type='text']", {
                                    value: BoardCentering.data.Captain,
                                    disabled: BoardCentering.editDisabled
                                })
                            ])
                        ]),
                        m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                            class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                        }, [
                            m("label.control-label.col-xs-6", "Летчики"),
                            m(".col-xs-6", [
                                m(".input-group", [
                                    m("input.form-control[name='CockpitCrew'][type='text']", {
                                        value: BoardCentering.data.CockpitCrew,
                                        disabled: BoardCentering.editDisabled
                                    }),
                                    m(".input-group-addon", "человек")
                                ])
                            ])
                        ]),
                        m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                            class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                        }, [
                            m("label.control-label.col-xs-6", "Бортпроводники"),
                            m(".col-xs-6", [
                                m(".input-group", [
                                    m("input.form-control[name='CabinCrew'][type='text']", {
                                        value: BoardCentering.data.CabinCrew,
                                        disabled: BoardCentering.editDisabled
                                    }),
                                    m(".input-group-addon", "человек")
                                ])
                            ])
                        ]),
                        m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                            class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                        }, [
                            m("label.control-label.col-xs-6", "Техники"),
                            m(".col-xs-6", [
                                m(".input-group", [
                                    m("input.form-control[name='Technics'][type='text']", {
                                        value: BoardCentering.data.Technics,
                                        disabled: BoardCentering.editDisabled
                                    }),
                                    m(".input-group-addon", "человек")
                                ])
                            ])
                        ]),
                        BoardCentering.data.flightType === flightTypes.departure ?
                            m.component(DepartureCenteringBlock, {
                                openSkyBlocksShow: BoardCentering.openSkyBlocksShow
                            }) :
                            m.component(ArrivalCenteringBlock, {
                                openSkyBlocksShow: BoardCentering.openSkyBlocksShow
                            }),
                        m(".row", [
                            m(".col-xs-12[style='padding:5px 15px']", "Компоновка")
                        ]),
                        m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                            class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                        }, [
                            m("label.control-label.col-xs-6", "Количество кресел"),
                            m(".col-xs-6", [
                                m(".input-group", [
                                    m("input.form-control[name='TotalSeats'][type='text']", {
                                        value: BoardCentering.data.TotalSeats,
                                        disabled: BoardCentering.editDisabled
                                    }),
                                    m(".input-group-addon", "шт")
                                ])
                            ])
                        ]),
                        m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                            class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                        }, [
                            m("label.control-label.col-xs-6", "Кресел бизнес"),
                            m(".col-xs-6", [
                                m(".input-group", [
                                    m("input.form-control[name='BussinessSeats'][type='text']", {
                                        value: BoardCentering.data.BusinessSeats,
                                        disabled: BoardCentering.editDisabled
                                    }),
                                    m(".input-group-addon", "шт")
                                ])
                            ])
                        ]),
                        m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                            class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                        }, [
                            m("label.control-label.col-xs-6", "Кресел эконом"),
                            m(".col-xs-6", [
                                m(".input-group", [
                                    m("input.form-control[name='EconomSeats'][type='text']", {
                                        value: BoardCentering.data.EconomSeats,
                                        disabled: BoardCentering.editDisabled
                                    }),
                                    m(".input-group-addon", "шт")
                                ])
                            ])
                        ]),
                        m(".row[style='margin:15px -15px']", [
                            m(".col-xs-12", [
                                m("button.btn.btn-info.btn-block.btn-lg[type='submit']", {
                                    disabled: BoardCentering.editDisabled
                                }, "Сохранить")
                            ])
                        ])
                    ]),
                    BoardCentering.alert,
                    (BoardCentering.openSkyBlocksShow && typeof BoardCentering.fuel.flightId != 'undefined') && user.get('showFuelBlock')
                    && BoardCentering.data.flightType === flightTypes.departure ?
                        //true ?
                        m("form.form-horizontal[style='margin-top:10px']", {
                            onsubmit: BoardCentering.saveFuel.bind(ctrl)
                        }, [
                            m("input[type='hidden'][name='flightId']", {value: BoardCentering.fuel.flightId}),
                            m(".row", [
                                m(".col-xs-12[style='padding:5px 15px']", "Топливо")
                            ]),
                            m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                                class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                            }, [
                                m("label.control-label.col-xs-6", "Топливо из NAV"),
                                m(".col-xs-6", [
                                    m("input.form-control[name='FuelFromNav'][type='text']", {
                                        readonly: 'readonly',
                                        value: BoardCentering.fuel.FuelFromNav || ''
                                    })
                                ])
                            ]),
                            m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                                class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                            }, [
                                m("label.control-label.col-xs-6", "Топливо из OFP"),
                                m(".col-xs-6", [
                                    m("input.form-control[name='FuelFromOFP'][type='text']", {
                                        readonly: 'readonly',
                                        value: BoardCentering.fuel.FuelFromOFP || ''
                                    })
                                ])
                            ]),
                            m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                                class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                            }, [
                                m("label.control-label.col-xs-6", "Топливо из OFP подтвержденное"),
                                m(".col-xs-6", [
                                    m("input.form-control[name='FuelFromOFPConfirmed'][type='text']", {
                                        readonly: 'readonly',
                                        value: BoardCentering.fuel.FuelFromOFPConfirmed || ''
                                    })
                                ])
                            ]),
                            m(".form-group[style='padding:7px 0;margin:0 0 5px 0;border-radius:4px']", {
                                class: BoardCentering.data.flightType === flightTypes.departure ? 'bg-danger' : 'bg-info'
                            }, [
                                m("label.control-label.col-xs-6", "Подтвержденное количество топлива"),
                                m(".col-xs-6", [
                                    m("input.form-control[name='FuelConfirmed'][type='text']", {
                                        readonly: 'readonly',
                                        value: BoardCentering.fuel.FuelConfirmed || ''
                                    })
                                ])
                            ]),
                            m(".row[style='margin:15px -15px']", [
                                m(".col-xs-12", [
                                    m("button.btn.btn-success.btn-block.btn-lg[type='submit']",
                                        {
                                            disabled: (
                                                BoardCentering.fuel.FuelFromOFPConfirmed <= 0
                                                ||
                                                (BoardCentering.fuel.FuelFromOFPConfirmed > 0 && BoardCentering.fuel.FuelFromOFPConfirmed == BoardCentering.fuel.FuelConfirmed)
                                            ) || false
                                        }, "Подтвердить")
                                ])
                            ])
                        ]) : ''
                ])
            ];
    }
};
